<template>
<v-container fluid>
  <v-row dense>
    <v-col cols="12">
      <v-btn class="mx-2" color="info" @click="successAction({ action: 'restructurarData', item: {} })" tile dark>
        <v-icon left>mdi-plus</v-icon> Restructurar Cantidades
      </v-btn>
    </v-col>
  </v-row>

  <v-divider width="5" class="pa-3 black--text" />

  <v-tabs v-model="tabMain" background-color="primary" dark>
    <v-tab v-for="(item, index) in estatus" :key="index" @click="getStatusAlmacen(item.id)">
      {{ item.nombre }} ({{ item.estatus }})
    </v-tab>
  </v-tabs>
    <v-layout justify-center>
        <v-flex md12>
          <v-row dense>
            <v-col cols="12">
              <DataTable :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
            </v-col>
          </v-row>
        </v-flex>
    </v-layout>
    <InsumoAlmacenDialog v-if="get_dialogMain.dialog&& get_dialogMain.type != 'salidasPrint'" :model="insumo" :params="params"/>
    <InsumoSalidaImprimirDialog v-if="get_dialogMain.dialog && get_dialogMain.type == 'salidasPrint'" :model="insumo"/>
</v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import DataTable from '@/components/dataTableMain'
import InsumoAlmacenDialog from '@/components/dialog/inventarios/InsumoAlmacenDialog'
import InsumoSalidaImprimirDialog from '@/components/dialog/inventarios/InsumoSalidaImprimirDialog'
import { Permission } from '@/mixins/permissionMain'
export default {
  mixins: [Permission],
  data: () => ({
    tabMain: 0,
    estatus: [],
    statusSelected: {},
    selected: 0,
    nameStatus: '',
    table: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Ingresar', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'inventario.execute.Entry-Insumo' }
        ],
        titles: [
          { text: 'Folio', value: 'folio', class: 'black--text' },
          { text: 'Insumo', value: 'NombreEquipo', class: 'black--text' },
          { text: 'Marca', value: 'MarcaModelo', class: 'black--text' },
          { text: 'Disponible', value: 'inventarios.checkin', class: 'black--text', align: 'center' },
          { text: 'Estatus', value: 'Status', align: 'center', class: 'black--text' },
          { text: '', value: 'Actions', class: 'black--text', align: 'right' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: {
        paging: true
      }
    },
    insumo: {},
    params: {}
  }),
  components: {
    DataTable,
    InsumoAlmacenDialog,
    InsumoSalidaImprimirDialog
  },
  mounted () {
    this.getDataUrl('tipo-actividad.list-status')
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['getUrlServices', 'urlGetServicesActionOne', 'urlGetServicesActionList', 'urlGetServiceActionTwo',
      'getInsumosByStatus', 'getInsumosStock']),
    ...mapMutations(['SHOW_DIALOG_MAIN']),

    getStatusAlmacen (id) {
      this.statusSelected = id
      this.table.header.loading = true
      const router = this.get_urls['inventarios.by-status']
      this.urlGetServicesActionList({ url: router, params: `/${id}`, replace: '/{status}' })
    },

    getDataUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        this.urlGetServicesActionOne({ url: router })
      } else {
        this.getUrlServices()
      }
    },
    getStatusById (url) {
      const router = this.get_urls[url]
      this.urlGetServicesActionList({ url: router, params: `/${this.statusSelected}`, replace: '/{status}' })
    },
    // ========== ========== ========== ========== ========== ========== ========== ==========
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      if (this.statusSelected) {
        this.table.header.loading = true
        this.getStatusById('inventarios.by-status')
      }
    },
    newData (item) {
      this.insumo = {}
      this.params = {}
      this.SHOW_DIALOG_MAIN({ type: 'process', with: 500, title: 'Ingresar Insumo' })
    },
    restructurarData (item) {
      this.$swal.fire({
        title: 'Estas seguro de restructurar las cantidades ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, restructurar !',
        cancelButtonText: 'Cerrar'
      }).then((result) => {
        if (result.value) {
          const url = this.get_urls['inventarios.struct-cant']
          this.urlGetServiceActionTwo({ url: url })
        }
      })
    },
    outInsumoData (item) {
      this.insumo = {}
      this.params = { tableShow: true, form: this.get_InsumosForm }
      this.SHOW_DIALOG_MAIN({ type: 'generalList', with: 650, title: 'Ingresar Insumo' })
    },
    // ========== ========== ========== ========== ========== ========== ========== ==========
    tableAction (item) {
      this[item.action](item)
    },
    toStock (item) {
      this.insumo = item
      this.params = {}
      this.SHOW_DIALOG_MAIN({ type: 'process', with: 500, title: 'Entrada a Stock' })
    },
    toPicking (item) {
      this.insumo = item
      this.params = {}
      this.SHOW_DIALOG_MAIN({ type: 'process', with: 500, title: 'Entrada a Picking' })
    },
    toAssign (item) {
      this.insumo = item
      this.params = {}
      this.SHOW_DIALOG_MAIN({ type: 'process', with: 900, title: 'Salida de Insumo' })
    },
    toReturnPicking (item) {
      this.insumo = item
      this.params = {}
      this.SHOW_DIALOG_MAIN({ type: 'process', with: 500, title: 'Regresar a Picking' })
    },
    toPrintInsumo (item) {
      this.insumo = item
      this.SHOW_DIALOG_MAIN({ type: 'salidasPrint', with: 1100, title: 'Salida de Insumo Imprimir' })
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_object', 'get_objects', 'get_dialogMain', 'get_objectExport',
      'get_InsumosForm'])
  },
  watch: {
    get_urls (val) {
      this.getDataUrl('tipo-actividad.list-status')
    },
    get_object (val) {
      if (val) {
        this.estatus = []
        this.estatus = val.estatus
        this.getStatusAlmacen(val.estatus[0].id)
      }
    },
    get_objects (vals) {
      if (vals) {
        const title = this.table.header.titles.find(a => a.text === 'Disponible')
        if (title) {
          if (this.statusSelected === 6) title.value = 'inventarios.checkin'
          if (this.statusSelected === 7) title.value = 'inventarios.stock'
          if (this.statusSelected === 8) title.value = 'inventarios.picking'
          if (this.statusSelected === 9) title.value = 'inventarios.out'
        }
        this.table.body.data = vals
        this.table.header.loading = false
      }
    },
    get_insumos (items) {
      this.table.body.data = items
      this.table.header.loading = false
    },
    get_objectExport (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error !',
          text: val.message
        })
        return
      }
      const linkSource = `data:application/pdf;base64,${val}`
      const downloadLink = document.createElement('a')
      const fileName = 'formato.pdf'
      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    }
  }
}
</script>

<style>

</style>
